import { ValidationObserver, ValidationProvider, extend } from "vee-validate";
import { required, email } from "vee-validate/dist/rules";
import { mapState } from "vuex";
import ForgotPasswordDialog from "@/views/modals/forgot-password";

// No message specified.
extend("email", email);

// Override the default message.
extend("required", {
  ...required,
  message: "Este campo es requerido"
});

export default {
  computed: {
    ...mapState({
      status: state => state.Authenticate.status
    })
  },
  data: () => ({
    showForgotPassword: false,
    validation_message: "",
    valid: false,
    user: {
      email: "",
      password: ""
    },
    show1: ""
  }),
  methods: {
    async login() {
      const self = this;
      const valid = await this.$refs.validator.validate();
      self.setValidationMessage("");
      if (valid) {
        self.$store
          .dispatch("Authenticate/login", self.user)
          .then(value => {
            if (value) {
              if (value.user_role === "provider") {
                self.$router.push("/admin/metrics");
              } else {
                self.$router.push("/admin/metrics");
              }
            }
          })
          .catch(() => {
            self.setValidationMessage("Invalid email/password");
          });
      }
    },
    setValidationMessage(message) {
      this.validation_message = message;
    },
    hideForgotPassword() {
      this.showForgotPassword = false;
    }
  },
  components: {
    ValidationProvider,
    ValidationObserver,
    ForgotPasswordDialog
  }
};
